import './scss/_bestilltid.css';
export default function Bestilltid() {
    return (
        <a href="https://footaura.bestille.no" target="_blank" rel="noopener noreferrer" className="btn">
        <button className="bestill-btn main-button">
            Bestill time
        </button>
        </a>
    );
}